import { Trip } from 'schema-dts';
import { jsonLdScriptProps } from 'react-schemaorg';
import Script from 'next/script';

import { TourDetailViewModel } from '@api/v3';
import useGetasPath from '@hooks/useGetasPath';

export const TourSchemaOrg = ({
  tourDetail,
}: {
  tourDetail: TourDetailViewModel;
}) => {
  const asPath = useGetasPath();
  const url = `${process.env.NEXT_PUBLIC_HOST}${asPath}`;
  return (
    <Script
      defer
      {...jsonLdScriptProps<Trip>({
        '@context': 'https://schema.org',
        '@type': 'TouristTrip',
        name: tourDetail.name,
        description: tourDetail.metaDescription,
        itinerary: tourDetail.programs?.map((itinerary) => ({
          '@type': 'TouristAttraction',
          name: itinerary.name, //tour program name
          description: itinerary.description,
        })),
        offers: {
          '@type': 'Offer',
          url,
          price: tourDetail.lowestPrice?.price, //bu alana turun fiyatı dinamik olarak eklenmelidir//
          priceCurrency: tourDetail.lowestPrice?.currency, //bu alana hangi para birimiyle ödeme alınacağı bilgisi
        },
      })}
    />
  );
};
